import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76e3f2f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-invest-wrap" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = { class: "company-invest-list" }
const _hoisted_4 = { class: "company-invest-hd" }
const _hoisted_5 = { class: "company-invest-info" }
const _hoisted_6 = { class: "company-invest-title" }
const _hoisted_7 = { class: "company-invest-des" }
const _hoisted_8 = { class: "company-invest-name" }
const _hoisted_9 = { class: "load-more" }

import Bottom from "../components/bottom.vue";
import store from '@/store/index';
import { useStore } from '@/store/index';
import { ref, reactive } from 'vue';
import tool from '@/utils/tool';
import router from '@/router/index';
import { ElButton, ElMessage, ElMessageBox } from 'element-plus';

interface PrototypeRoomVo {
  id: string;
  name: string;
  houseNatureId: string;
  decorateTypeId: string;
  decorateStyleId: string;
  projectId: string;
  projectName: string;
  remark: string;
  vrUrl: string;
  imageUriList: string[];
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref(true);
const remainCount = ref(0)

var id = router.currentRoute.value.params.id;

const bindData = reactive({
  prototypeRoomPageParams: {
    curPage: 1,
    pageSize: 9,
    filtrate: {
      companyCode: id,
      keyword: '',
    },
  },
  prototypeRoomPageResult: {
    status: 2000,
    msg: '成功',
    result: [],
    totalCount: 0,
  },
});

const searchEvent = (isAppend: boolean) => {
  loading.value = true;
  store
    .dispatch(
      'frontCompanyModule/pagePrototypeRoomList',
      bindData.prototypeRoomPageParams
    )
    .then(
      (data) => {
        //成功
        if (isAppend) {
          data.result = bindData.prototypeRoomPageResult.result.concat(data.result);
        }
        bindData.prototypeRoomPageResult = data;
        remainCount.value = data.totalCount - bindData.prototypeRoomPageResult.result.length;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

searchEvent(false);

const loadPageDataEvent = () => {
  if (bindData.prototypeRoomPageParams.curPage * bindData.prototypeRoomPageParams.pageSize < bindData.prototypeRoomPageResult.totalCount) {
    bindData.prototypeRoomPageParams.curPage = bindData.prototypeRoomPageParams.curPage + 1;
    searchEvent(true);
  }
};


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, { class: "company-invest-search" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { class: "company-invest-search-text" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入关键字搜索",
                size: "large",
                modelValue: _unref(bindData).prototypeRoomPageParams.filtrate.keyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).prototypeRoomPageParams.filtrate.keyword) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { class: "company-invest-search-btn" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElButton), {
                type: "primary",
                size: "large",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (searchEvent(false)))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).prototypeRoomPageResult.result, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "company-invest-item",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_carousel, {
                class: "bbs-detail-ad",
                height: "200px"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imageList, (image) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, {
                      key: image.id,
                      style: {"display":"flex","justify-content":"center"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_image, {
                          class: "company-invest-banner",
                          mode: "widthfix",
                          src: image.thumbnailUrl
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.houseNatureName || "--") + " | " + _toDisplayString(item.decorateTypeName || "--") + " | " + _toDisplayString(item.decorateStyleName || "--"), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.projectName || "--") + " | " + _toDisplayString(item.companyName || "--"), 1)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_unref(bindData).prototypeRoomPageResult.result.length < _unref(bindData).prototypeRoomPageResult.totalCount)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              class: "load-more-button",
              type: "text",
              size: "large",
              onClick: loadPageDataEvent
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 加载更多..." + _toDisplayString(remainCount.value), 1),
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowDownBold)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(Bottom, { class: "company-invest-bottom" })
  ]))
}
}

})